// Dev/prod API base. CRA sets NODE_ENV=development for `npm start` (local dev
// server) and production for `npm run build`. So local dev hits the local
// backend (localhost:8081, matching the backend's `npm run dev` CORS), and the
// deployed build hits production. Override with REACT_APP_API_URL if needed.
export const baseUrl =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'development'
    ? 'http://localhost:8081/api/'
    : 'https://hire.1maintenance.com.au/api/');

// --- Item identifier display rule (shared across the whole app) ---
// ItemNo is the primary identifier; CatNo is shown as the secondary value.
//   Tight spaces (chips, single-line cells)   -> itemPrimaryLabel -> "ItemNo"
//   Roomy spaces (option rows, search, headers) -> itemFullLabel  -> "ItemNo (CatNo)"
// CatNo stays the internal record key everywhere (form state, equality, payloads);
// only the displayed string changes. Helpers accept camelCase or snake_case fields.
const _itemNo = (a) => (a ? (a.itemNo ?? a.item_no ?? null) : null);
const _catNo = (a) => (a ? (a.catNo ?? a.cat_no ?? null) : null);

export const itemPrimaryLabel = (a) => _itemNo(a) || _catNo(a) || '';

export const itemFullLabel = (a) => {
  const id = _itemNo(a);
  const cat = _catNo(a);
  if (id && cat) return `${id} (${cat})`;
  return id || cat || '';
};